import { TableHead, TableCell, TableBody, Table, TableRow } from '@mui/material';
import { Link } from 'react-router-dom';
import { WidgetPanel } from './WidgetPanel';
import { WidgetTitle } from './WidgetTitle';
import { useState } from 'react';
import { useQuery } from '@apollo/client/react';
import LoadingSpinner from '../components/LoadingSpinner';
import { GET_LICENSES_WITH_HIGH_USAGE } from '../reports/reports.graphql';

interface License {
  licenseId: string;
  companyName: string;
  orgNumber: string;
  views: string;
}

const LinkToDetails = (props) => (
  <Link to={`/report?tab=4&offset=${props.offset}`} title={props.title}>
    {props.children}
  </Link>
);

export function LicensesWithHighUsage() {
  const [monthOffset, setMonthOffset] = useState(0); // get statistics for current month, default

  var take = 5;

  const { loading, data } = useQuery<any, any>(GET_LICENSES_WITH_HIGH_USAGE, {
    variables: { monthOffset: monthOffset, take: take },
    fetchPolicy: 'network-only',
  });

  return (
    <div>
      <WidgetPanel>
        <WidgetTitle
          title="Topp 5 aktive kunder i"
          offset={monthOffset}
          forwardLimit={1}
          stateSetter={(step) => {
            setMonthOffset(monthOffset + step);
          }}
        />

        {loading && <LoadingSpinner />}
        {!loading && !data && <div>Mangler data</div>}
        {data && renderDetails(data.licenses)}
        <LinkToDetails offset={monthOffset}>Se mer</LinkToDetails>
      </WidgetPanel>
    </div>
  );

  function renderDetails(licenses) {
    return (
      <Table padding="none">
        <TableHead>
          <TableRow>
            <TableCell>Navn</TableCell>
            <TableCell align="right">Antall sidevisninger</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {licenses.map((license: License) => {
            return (
              <TableRow key={license.licenseId}>
                <TableCell>
                  <Link to={`/license/${license.licenseId}`}>{license.companyName}</Link>
                </TableCell>
                <TableCell align="right">{license.views}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    );
  }
}
